import type { ColDef, ValueGetterParams } from '@ag-grid-community/core';

import type { RecordOverviewPartnerType } from '@/types/individual_record';

import IRPContactsCountCell from './IRPContactsCountCell.vue';
import IRPDataSourceCell from './IRPDataSourceCell.vue';
import IRPOwnerCell from './IRPOwnerCell.vue';
import IRPPartnerCell from './IRPPartnerCell.vue';
import IRPPartnerScoreCell from './IRPPartnerScoreCell.vue';
import IRPPopulationsCell from './IRPPopulationsCell.vue';

export function useRecommendedPartnersColumnDefinitions(): ColDef[] {
  return [
    {
      field: 'partner_name',
      headerName: 'Partner',
      cellRenderer: IRPPartnerCell,
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'partner_score_bucket',
      headerName: 'Partner Score',
      cellRenderer: IRPPartnerScoreCell,
      width: 140,
    },
    {
      field: 'partner_account_owner.name',
      headerName: 'Partner Account Owner',
      cellRenderer: IRPOwnerCell,
      minWidth: 180,
    },
    {
      field: 'contacts_common_count',
      headerName: 'Contacts',
      cellRenderer: IRPContactsCountCell,
      width: 180,
    },
    {
      headerName: 'Open Opportunities',
      valueGetter: ({ data }: ValueGetterParams<RecordOverviewPartnerType>) =>
        data?.open_opportunities_count ?? 0,
      width: 160,
    },
    {
      field: 'shared_with_us_population_ids',
      headerName: 'Populations',
      cellRenderer: IRPPopulationsCell,
      minWidth: 180,
    },
    {
      field: 'data_source.label',
      headerName: 'Data Source',
      cellRenderer: IRPDataSourceCell,
      width: 160,
    },
  ];
}
